<template>
    <div class="backoffice-reports-index">
        <v-row v-if="$page.props.p['reports']"> 
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/members">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.members || "Members" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-account-multiple-check-outline</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ members }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/subscriptions">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.subscriptions || "Memberships" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-cash-plus</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ subscriptions }}</span></h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/visits">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.visits || "Visits" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-check-all</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ visits }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/appointmentsMembers">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.appointmentsMembers || "Appointments Members" }}</v-card-title>
                        <v-row>
                            <v-col  cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-calendar-month-outline</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ appointmentMembers }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/appointmentsTrainers">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.appointmentsTrainers || "Appointments Trainers" }}</v-card-title>
                        <v-row>
                            <v-col  cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-calendar-month-outline</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ appointmentTrainers }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/courses">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.courses || "Courses" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile>
                                    <v-icon>mdi-dumbbell</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ courses }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
            <v-col cols="12" sm="6" md="3">
                <inertia-link href="/backoffice/reports/income">
                    <v-card elevation="1">
                        <v-card-title>{{ $page.props.lang.earnings || "Income" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile>
                                    <p class="mb-2 ml-2">{{$page.props.organization.settings.currency}}</p>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value">{{ income }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </inertia-link>
            </v-col>
        </v-row>
    </div>
</template>


<script>
import AppLayout from '@/js/Layouts/AppLayout'


export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Reports"
        }
    },
    layout: AppLayout,
    props: {
        debt: Number,
        members: Number,
        appointments: Number,
        subscriptions: Number,
        visits: Number,
        appointmentMembers: Number,
        appointmentTrainers: Number,
        courses: Number,
        income: String
    },
    data(){
        return {
       
        }
    },
     created(){
    
    },
    methods: {
 
    }
}

</script>